import { WorkItemTypes } from '../constants/workitem-types';
import { WorkItemPool } from '../workitem-pool';
import { WorkItem } from '../interfaces/workitem-base.interface';
import { ThemeServiceHelper } from 'common/theme/service.helper';

export class WorkItemBase implements WorkItem {
  public type: string;
  public keepAlive: boolean;
  public isClosable: boolean;

  protected _id: string;
  protected _avatarThemeId: number | string;
  protected _isCollapsible: boolean;

  constructor(workItem: any = {}) {
    this._id = workItem.id || workItem.ItemID || null;
    this._avatarThemeId = workItem.avatarThemeId || null;
    this.keepAlive = false;

    const workItemPool = WorkItemPool.getInstance();
    workItemPool.addWorkItem(this);
  }

  get id() {
    return this._id;
  }

  get avatarThemeId(): string | number {
    if (!this._avatarThemeId) {
      this._avatarThemeId = ThemeServiceHelper.getAvatarThemeId(this._id);
    }

    return this._avatarThemeId;
  }

  public get isCollapsible(): boolean {
    return this._getCollapsible();
  }

  protected _getCollapsible(): boolean {
    return this._isCollapsible;
  }

  isChat(): boolean {
    return this.type === WorkItemTypes.CHAT;
  }

  isChatPinInvite(): boolean {
    return this.type === WorkItemTypes.CHAT_PIN_INVITE;
  }

  isEmail(): boolean {
    return this.type === WorkItemTypes.EMAIL;
  }

  isComposeEmail(): boolean {
    return this.type === WorkItemTypes.COMPOSE_EMAIL;
  }

  isSms(): boolean {
    return this.type === WorkItemTypes.SMS;
  }

  isLens(): boolean {
    return this.type === WorkItemTypes.LENS;
  }

  isFacebook(): boolean {
    return this.type === WorkItemTypes.FACEBOOK;
  }

  isDiscussion(): boolean {
    return this.type === WorkItemTypes.DISCUSSION;
  }

  isAsyncMessage(): boolean {
    return this.type === WorkItemTypes.ASYNC_MESSAGE;
  }

  isMessage(): boolean {
    return this.isSms() || this.isFacebook() || this.isAsyncMessage();
  }

  isGenesysChat(): boolean {
    return this.type === WorkItemTypes.GENESYS_CHAT;
  }

  isGenesysEmail(): boolean {
    return this.type === WorkItemTypes.GENESYS_EMAIL;
  }
}
